import { TvMinimalPlayIcon } from 'lucide-react'

import { DepositCTAPanelProps } from '../DepositCTAPanel'
import { BaseMiniAppOptions } from '@/base-miniapp/types'
import { Button } from '@/ui/atoms/button/Button'
import { IconButton } from '@/ui/atoms/icon-button/IconButton'
import { cn } from '@/ui/utils/style'

export interface ActionsProps {
  actions: DepositCTAPanelProps['actions']
  skipSecondaryAction: boolean
  className?: string
  baseMiniAppOptions: BaseMiniAppOptions | undefined
}

export function Actions({ actions, skipSecondaryAction, className, baseMiniAppOptions }: ActionsProps) {
  if (baseMiniAppOptions) {
    return (
      <div className={cn('grid grid-cols-[auto_1fr] gap-4 lg:grid-cols-2', className)}>
        <IconButton
          variant="secondary"
          icon={() => <TvMinimalPlayIcon className="icon-secondary" />}
          onClick={baseMiniAppOptions.openTutorialDialog}
          className="justify-self-end"
          size="l"
        />
        <Button variant="primary" size="l" className="lg:col-start-2" onClick={actions.primary.action}>
          {actions.primary.title}
        </Button>
      </div>
    )
  }

  if (skipSecondaryAction) {
    return (
      <div className={cn('grid gap-4 lg:grid-cols-2', className)}>
        <Button variant="primary" size="l" className="lg:col-start-2" onClick={actions.primary.action}>
          {actions.primary.title}
        </Button>
      </div>
    )
  }
  return (
    <div className={cn('grid grid-cols-2 gap-4', className)}>
      <Button variant="primary" size="l" onClick={actions.primary.action}>
        {actions.primary.title}
      </Button>
      <Button variant="secondary" size="l" onClick={actions.secondary.action} disabled={skipSecondaryAction}>
        {actions.secondary.title}
      </Button>
    </div>
  )
}
